var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import styled from "styled-components";
export var Button = React.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.buttonType, buttonType = _b === void 0 ? "primary" : _b, props = __rest(_a, ["children", "buttonType"]);
    if (buttonType === "primary") {
        return (_jsx(Primary, __assign({ ref: ref }, props, { children: children })));
    }
    if (buttonType === "secondary") {
        return (_jsx(Secondary, __assign({ ref: ref }, props, { children: children })));
    }
    return null;
});
var Base = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: fit-content;\n  min-width: fit-content;\n  cursor: pointer;\n  border-radius: 4px;\n  border: none;\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n\n  svg {\n    margin-right: 0.5rem;\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--dark-blue) !important;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  :disabled {\n    cursor: not-allowed;\n    background-color: #1867be;\n  }\n"], ["\n  width: fit-content;\n  min-width: fit-content;\n  cursor: pointer;\n  border-radius: 4px;\n  border: none;\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n\n  svg {\n    margin-right: 0.5rem;\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--dark-blue) !important;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  :disabled {\n    cursor: not-allowed;\n    background-color: #1867be;\n  }\n"])));
var Primary = styled(Base)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: var(--dark-blue);\n  color: #fff;\n\n  svg {\n    fill: #fff;\n  }\n\n  &:hover {\n    background-color: var(--dc-blue-hover);\n  }\n"], ["\n  background-color: var(--dark-blue);\n  color: #fff;\n\n  svg {\n    fill: #fff;\n  }\n\n  &:hover {\n    background-color: var(--dc-blue-hover);\n  }\n"])));
var Secondary = styled(Base)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: var(--secondary);\n  color: #3f4254;\n\n  svg {\n    fill: #3f4254;\n  }\n\n  &:hover {\n    background-color: var(--light-gray);\n  }\n"], ["\n  background-color: var(--secondary);\n  color: #3f4254;\n\n  svg {\n    fill: #3f4254;\n  }\n\n  &:hover {\n    background-color: var(--light-gray);\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3;
